import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { IotDeviceApiService } from '../iot-device-api.service';
import { IotDevice } from '../../model/iot-device.model';
import {
  CreateDevice,
  DeleteDevice,
  LoadDevices,
  UpdateDevice,
} from './iot-device.actions';

export interface IotDevicesStateModel {
  devices: IotDevice[];
  total: number;
}

@State<IotDevicesStateModel>({
  name: 'iotDevices',
  defaults: {
    devices: [],
    total: 0,
  },
})
@Injectable()
export class IotDevicesState {
  private readonly api = inject(IotDeviceApiService);

  @Selector()
  static getDevices(state: IotDevicesStateModel): IotDevice[] {
    return state.devices;
  }

  @Selector()
  static getTotal(state: IotDevicesStateModel): number {
    return state.total;
  }

  @Action(LoadDevices)
  loadDevices(
    ctx: StateContext<IotDevicesStateModel>,
    { page, maxResults }: LoadDevices,
  ) {
    return this.api.getDevices(page, maxResults).pipe(
      tap((response) =>
        ctx.patchState({
          devices: response.devices,
          total: response.meta.totalRecords,
        }),
      ),
    );
  }

  @Action(CreateDevice)
  createDevice(
    _ctx: StateContext<IotDevicesStateModel>,
    { payload }: CreateDevice,
  ) {
    return this.api.createDevice(payload);
  }

  @Action(UpdateDevice)
  updateDevice(
    _ctx: StateContext<IotDevicesStateModel>,
    { id, payload }: UpdateDevice,
  ) {
    return this.api.updateDevice(id, payload);
  }

  @Action(DeleteDevice)
  deleteDevice(
    _ctx: StateContext<IotDevicesStateModel>,
    { id }: DeleteDevice,
  ) {
    return this.api.deleteDevice(id);
  }
}
